import { render, staticRenderFns } from "./ProjectDetailsMarginField.vue?vue&type=template&id=3ee24578&scoped=true"
import script from "./ProjectDetailsMarginField.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailsMarginField.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetailsMarginField.vue?vue&type=style&index=0&id=3ee24578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee24578",
  null
  
)

export default component.exports